module.exports = __webpack_public_path__ + "media/victory.e91046c8.mp3";